"use client";

import { Box, Button, HStack, Text } from "@chakra-ui/react";
import { useState } from "react";
import type { QuestionnaireViewMode } from "@/shared/types";
import GenericCollapsible from "@/shared/ui/display/GenericCollapsible";
import GenericIcon from "@/shared/ui/actions/GenericIcon";
import GenericSelector from "@/shared/ui/controls/GenericSelector";
import { useOptionItems } from "@/shared/ui/controls/useOptionItems";
import { useUserChoices } from "@/state/globalStore";
import ScaleInfo from "./ScaleInfo";

export default function ReflectQuestionnaireControls() {
  const { questionnaireViewModeItems } = useOptionItems();
  const { questionnaireViewModes, setQuestionnaireViewModes } =
    useUserChoices();
  const [isScaleOpen, setIsScaleOpen] = useState(false);

  return (
    <>
      <HStack align="center" gap="2" width="full">
        <Box flex="1" minW="0">
          <GenericSelector<QuestionnaireViewMode>
            previewItems={questionnaireViewModeItems}
            stateObject={questionnaireViewModes}
            stateObjectSetter={setQuestionnaireViewModes}
            initValue={questionnaireViewModes[0]}
            mode="select"
            allowMultiple={false}
            disableClear={true}
          />
        </Box>
        <Button
          type="button"
          variant="outline"
          onClick={() => setIsScaleOpen((isOpen) => !isOpen)}
          aria-label={
            isScaleOpen ? "Hide scale information" : "Show scale information"
          }
          minW={{ base: "10", sm: "auto" }}
        >
          <GenericIcon icon="inform" highlighted={isScaleOpen} />
          <Text as="span" display={{ base: "none", sm: "inline" }}>
            Scale
          </Text>
        </Button>
      </HStack>

      {isScaleOpen && questionnaireViewModes.length > 0 && (
        <GenericCollapsible
          isOpen={isScaleOpen}
          setIsOpenAction={setIsScaleOpen}
          defaultOpen={false}
          setChildrenBorder={true}
        >
          <ScaleInfo />
        </GenericCollapsible>
      )}
    </>
  );
}
